import { PlanType } from '@labrav/react-components'
import { CloudMarketplace } from '../../modules/productsListing/reducer'

const getAzureTextForProduct = (productType: PlanType | string) => {
  switch (String(productType).toUpperCase()) {
    case 'SAAS':
    case PlanType.SAAS_CONTRACT:
    case PlanType.SAAS_SUBSCRIPTION:
      return 'SaaS'
    case 'VM':
    case 'VIRTUAL_MACHINE':
      return 'VM'
    case PlanType.CONTAINER:
    case 'CONTAINER':
      return 'Container'
    default:
      return ''
  }
}

export const getTextForProduct = (
  productType: PlanType | string,
  cloudMarketplace?: CloudMarketplace
) => {
  if (cloudMarketplace === 'AZURE') {
    return getAzureTextForProduct(productType)
  }

  switch (productType) {
    case PlanType.SAAS_CONTRACT:
      return 'SaaS Contract'
    case PlanType.PROFESSIONAL_SERVICES:
      return 'Professional Service'
    case PlanType.SAAS_SUBSCRIPTION:
      return 'SaaS Subscription'
    case PlanType.CONTAINER:
      return 'Container'
    case PlanType.AMI:
      return 'AMI'
    default:
      return ''
  }
}
